import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import AvatarEdit from '../AvatarEdit';
import './index.scss';

const PhotoUpload = ({
  value,
  name,
  label,
  onChange,
  setFieldValue,
  setEditorRef,
  error,
  className,
}) => {
  const { t } = useTranslation('components');
  return (
    <div className={classnames('photo-upload', className)}>
      {value ? (
        <>
          <p className="photo-upload__title f-12">{label}</p>
          <AvatarEdit
            src={value.id ? value.file : value}
            name={name}
            setFieldValue={setFieldValue}
            setEditorRef={setEditorRef}
            className="photo-upload__editor"
          />
        </>
      ) : (
        <label
          htmlFor={name}
          className={classnames('photo-upload__label', error && 'photo-upload__label-error')}
        >
          <div className="photo-upload__centered">
            <p className="photo-upload__centered-title f-16">{label}</p>
            {error ? (
              <p className="cv-upload__centered-error f-12">{error}</p>
            ) : (
              <p className="cv-upload__centered-desc f-12">
                {t('photo_upload.upload_file_up_to', { size: '12Mb' })}
              </p>
            )}
          </div>
          <input
            type="file"
            name={name}
            id={name}
            onChange={onChange}
            className="photo-upload__input"
          />
        </label>
      )}
    </div>
  );
};

export default PhotoUpload;
